// extracted by mini-css-extract-plugin
export default {"form":"SearchBox_form__2wi7n","options":"SearchBox_options__Ws4Lc","moreOptions":"SearchBox_moreOptions__bYmR4","enable":"SearchBox_enable__a7EYO","vFlip":"SearchBox_vFlip__LLtTL"};